import { useContext } from 'react';
import { EXTERNAL_ROUTES, ROUTES } from '@/libs/routing';
import { useAnalytics } from '@/libs/analytics';
import { useRouter } from 'next/navigation';

import { PlanAction, PlanType } from '@/features/common/pricing';
import { IProductMetadata } from '@/features/pricingV2/domain';
import { PricingPageContext } from '@/features/pricingV2/ui/contexts';

type ActionDescriptor = {
  type: PlanAction;
  onClick: () => void;
  href?: string;
};

type UsePlanActions = (params: { metadata: IProductMetadata }) => ActionDescriptor;

export const usePlanActions: UsePlanActions = ({ metadata }) => {
  const router = useRouter();
  const { billingCycle } = useContext(PricingPageContext);
  const { pricingPageGetStartedClicked } = useAnalytics();

  const planId = metadata.variants[billingCycle]?.id;

  switch (true) {
    case metadata.family === PlanType.Free:
      return {
        type: PlanAction.GetStartedFree,
        onClick: (): void => {
          pricingPageGetStartedClicked();
        },
        href: planId
          ? `${EXTERNAL_ROUTES.DASHBOARD_SIGN_UP}?selected_plan=${planId}`
          : EXTERNAL_ROUTES.DASHBOARD_SIGN_UP,
      };
    case metadata.family === PlanType.Custom:
      return {
        type: PlanAction.TalkToSales,
        onClick: (): void => {
          router.push(`${ROUTES.DEMO}?source=expand`);
        },
        href: `${ROUTES.DEMO}?source=expand`,
      };
    case metadata.family === PlanType.Pro:
    case metadata.family === PlanType.Unlimited:
    default:
      return {
        type: PlanAction.GetStarted,
        onClick: (): void => {
          pricingPageGetStartedClicked();
        },
        href: planId
          ? `${EXTERNAL_ROUTES.DASHBOARD_SIGN_UP}?selected_plan=${planId}`
          : EXTERNAL_ROUTES.DASHBOARD_SIGN_UP,
      };
  }
};
